<template>
    <div>

    </div>
</template>

<script>
import VueSticky from 'vue-sticky'
import {shippingStates, publicationStates} from '@/common/states'
import {mapGetters, mapState} from "vuex";
import {productPricesOfFormat} from "@/common/utils";

export default {
    name: "OrderSummary",
    props: {
        products: Array,
        subtotal: Number,
        total: String,
        discounts: Array,
        shipping: Object,
        shippingCost: Number,
        totalTax: Number,
        taxrate: Number
    },
    directives: {
        'sticky': VueSticky,
    },
    computed: {
        ...mapState({
            cartData: (state) => state.checkout.cartData,
            multiyear: (state) => state.cart.multiyear,
        }),
        ...mapGetters (['isHomeschoolStore']),
    },
    data: () => ({
        states: shippingStates,
        publicationStates: publicationStates,
    }),
    mounted() {
        // console.log(this.cartData)
    },
    methods: {
        formattedState (productState) {
            var formattedState = null

            _.forEach(this.publicationStates, state => {
                if (productState == state.state) {
                    formattedState = state.fullState
                }
            })

            return formattedState
        },
        price (product_prices, format, type, quantity, multiyear) {
            const prices = productPricesOfFormat(product_prices, format, quantity, this.isHomeschoolStore)[multiyear];

            return prices
        },
    }

}
</script>

<style lang="scss"  scoped>
.products {
    img {
        width: 40px;
    }
}
</style>